import Header from "@/components/header/header";
import Loading from "@/components/loading/loading";
import { checkAccessPermission } from "@/utils/access-control";
import { getPasswordChangeType, getUserRoleFromCookie } from "@/utils/cookie-utils";
import { EXCLUDE_BREADCRUMB_PATH, MY_INFO_CHANGE_PD_PATH } from "@/utils/global-constants";
import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";

export default function HomeLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const isHome = EXCLUDE_BREADCRUMB_PATH.includes(path);
  const previousPathRef = useRef<string | null>(null);
  const [isCheckingPermission, setIsCheckingPermission] = useState(true);
  const [hasPermission, setHasPermission] = useState(false);

  console.log(`[HomeLayout] 현재 경로: ${path}, isHome: ${isHome}`);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        console.log(`[HomeLayout] fetchUserRole`);
        const userRole = await getUserRoleFromCookie();
        if (!userRole) {
          navigate("/", { replace: true });
          return;
        }
        console.log(`[HomeLayout] userRole from cookie:`, userRole);

        // 패스워드 변경이 필요한지 확인
        const passwordChangeRequired = getPasswordChangeType();

        // 패스워드 변경이 필요한 경우, 패스워드 변경 페이지가 아니면 리다이렉트
        if (passwordChangeRequired && path !== MY_INFO_CHANGE_PD_PATH) {
          console.log(
            `[HomeLayout] 패스워드 변경이 필요하여 패스워드 변경 페이지로 리다이렉트합니다.`
          );
          navigate(MY_INFO_CHANGE_PD_PATH, { replace: true });
          return;
        }

        const accessControlResult = checkAccessPermission(userRole, path);
        console.log(`[HomeLayout] path:`, path);
        console.log(`[HomeLayout] userRole:`, userRole);
        console.log(`[HomeLayout] accessControlResult:`, accessControlResult);

        if (!accessControlResult.hasAccess) {
          console.warn("[HomeLayout] 접근 권한이 없어 '/admin/home'으로 리다이렉트합니다.");
          navigate("/admin/home", { replace: true });
          return;
        }

        // 권한이 있는 경우에만 화면을 표시
        setHasPermission(true);
      } catch (error) {
        console.error(`[HomeLayout] :: 사용자 역할 조회 중 오류:`, error);
        navigate("/", { replace: true });
        return;
      } finally {
        // 권한 체크 완료
        setIsCheckingPermission(false);
      }
    };
    fetchUserRole();

    // 현재 경로를 이전 경로로 저장
    previousPathRef.current = path;
  }, [path, navigate]);

  console.log(
    `[HomeLayout] :: Breadcrumb 경로에 포함되어 헤더를 표시하지 않습니다. ${isHome} 이므로 페이지 top이 ${
      isHome ? "4rem" : "7.5rem"
    } 이 됩니다.`
  );

  // 권한 체크 중이거나 권한이 없는 경우 로딩 화면 표시
  // Outlet은 항상 렌더링하여 ModalProvider 컨텍스트를 유지
  if (isCheckingPermission || !hasPermission) {
    return (
      <div
        style={{
          paddingTop: isHome
            ? `var(--header-height-no-breadcrumb)`
            : `var(--header-height-with-breadcrumb)`,
        }}
      >
        <Header />
        <main>
          <Loading />
          <Outlet />
        </main>
      </div>
    );
  }

  return (
    <div
      style={{
        paddingTop: isHome
          ? `var(--header-height-no-breadcrumb)`
          : `var(--header-height-with-breadcrumb)`,
      }}
    >
      <Header />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
